<template>
  <div class="root">
    <router-link class="router-link"
                
                :to="{ name: 'Login' }">
      <img  :src="require('@/assets/logo.png')"
            
            alt="A Point - Build App"
          />
    </router-link>
  </div>
</template>

<style scoped>

  .root {
    padding: 0 20px;

    text-align: center;
  }

  .router-link {
    display: block;

    max-width: 264px;

    margin-left: auto;
    margin-right: auto;
  }

</style>